import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';
import ViewInfoProcess from './ViewInfoProcess';
import ProjectPercent from '../sumTotal/projectPercent';

class ProPercentModal extends Component {
    state = {
        data: {},
        record: {},
        loading: false,
        visible: false,
    }

    show = (record) => {
        this.setState({
            record,
            type: 'process',
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { record: { investigationId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationProgress,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data = {} } = res;
                this.setState({
                    data,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    };

    handleClick = (type) => {
        this.setState({
            type
        }, () => {
            type == 'process' && this.loadData();
        })
    }

    getProcessContent = () => {
        const { record: { investigationId } } = this.state;
        return (
            <div style={{ margin: '20px 0 ' }}>
                <ViewInfoProcess canEdit={false} investigationId={investigationId} />
            </div>
        )
    }

    getProPercentContent = () => {
        const { record: { investigationName, investigationId, investigationCode } } = this.state;
        return (
            <div style={{ padding: 20, textAlign: 'center' }}>
                <h1>项目完工百分比</h1>
                <h3 style={{ marginBottom: 20 }}>{investigationName} ({investigationCode})</h3>
                <ProjectPercent jde={true} invId={investigationId} scrollY={300} />
            </div>
        )
    }

    render() {
        const { visible, type = '' } = this.state;
        return (
            <Modal
                title={
                    <div>
                        <div className={`header-left${type == 'process' ? ' cur' : ''}`} onClick={() => this.handleClick('process')}>项目信息和进展</div>
                        <div className={`header-right${type == 'proPercent' ? ' cur' : ''}`} onClick={() => this.handleClick('proPercent')}>项目完工百分比明细</div>
                    </div>
                }
                visible={visible}
                closable={false}
                className="preview-modal toggle-detail"
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 600 }}
                maskClosable={false}
                width="1200px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                {visible && type == 'process' && this.getProcessContent()}
                {visible && type == 'proPercent' && this.getProPercentContent()}
            </Modal>
        )
    }
}

export default ProPercentModal


// WEBPACK FOOTER //
// ./src/components/investigation/ProPercentModal.js